<template>
  <div>
    <div class="col-md-12 row wrap pt-4">
      <table class="table table-white flex md6">
        <thead>
          <tr></tr>
        </thead>
        <tbody>
          <tr>
            <th scope="col">Reporter</th>
            <td v-if="crimeData.usertype === 'user'">
              {{ crimeData.uid.fullName }}
              <router-link
                v-if="appUser.usertype == 0"
                :to="'/userview/' + crimeData.uid._id"
              >
                <span class="text-info" style="cursor: pointer"
                  >View Details</span
                >
              </router-link>
            </td>

            <td
              v-if="
                crimeData.usertype == 'guest' && crimeData.anonymous == 'no'
              "
            >
              <span v-if="crimeData.name">{{ crimeData.name }}</span>
            </td>
            <td
              v-if="
                crimeData.usertype == 'guest' && crimeData.anonymous == 'yes'
              "
            >
              Guest
            </td>
          </tr>
          <tr v-if="crimeData.isAssigned">
            <th scope="col">Assigned To</th>
            <td v-if="crimeData.isAssigned">
              {{ crimeData.assignedTo[0].name }}
            </td>
          </tr>
          <tr
            v-if="crimeData.usertype == 'guest' && crimeData.anonymous == 'no'"
          >
            <th scope="col">Email</th>
            <td v-if="crimeData.email">{{ crimeData.email }}</td>
          </tr>
          <tr
            v-if="crimeData.usertype == 'guest' && crimeData.anonymous == 'no'"
          >
            <th scope="col">Phone</th>
            <td v-if="crimeData.phone">{{ crimeData.phone }}</td>
          </tr>
          <tr v-if="crimeData.contributorName">
            <th scope="col">Suspect Name</th>
            <td class="text-capitalize">{{ crimeData.contributorName }}</td>
          </tr>
          <tr v-if="crimeData.contributorEmail">
            <th scope="col">Suspect Email</th>
            <td class="text-capitalize">{{ crimeData.contributorEmail }}</td>
          </tr>
          <tr v-if="crimeData.contributorPhone">
            <th scope="col">Suspect Phone</th>
            <td class="text-capitalize">{{ crimeData.contributorPhone }}</td>
          </tr>
          <tr v-if="crimeData.description != ''">
            <th scope="col">Description</th>
            <td style="text-align: justify">{{ crimeData.description }}</td>
          </tr>

          <tr v-if="crimeData.remarks">
            <th scope="col">Remarks</th>
            <td>{{ crimeData.remarks }}</td>
          </tr>
          <tr v-if="crimeData.url != ''">
            <th scope="col">Url</th>
            <td style="text-align: justify">
              <a :href="crimeData.url">{{ crimeData.url }}</a>
            </td>
          </tr>
           <tr v-if="crimeData.adminDescription">
            <th scope="col">Admin Description</th>
            <td style="text-align: justify">
              <!-- <a :href="crimeData.adminDescription">{{ crimeData.adminDescription }}</a> -->
              <p>{{ crimeData.adminDescription }}</p>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-white flex md6">
        <tbody>
          <tr v-if="crimeData.create_date">
            <th>Date</th>
            <td>{{formatDate(crimeData.create_date)}}</td>
          </tr>
          <tr>
            <th v-if="crimeData.status" scope="col" id="status">Status</th>
            <td style="font-weight: 500">
              {{ crimeData.status }}
              <span
                v-b-modal.modal-footer-sm
                class="text-info"
                style="cursor: pointer"
                >Update</span
              >
              <b-modal id="modal-footer-sm" title button-size="sm" hide-footer>
                <form @submit="onSubmit">
                  <div class="form-group">
                    <h5 style="color: black!important; padding-bottom: 20px">
                      Update Status
                    </h5>
                    <b-form-select
                      required
                      placeholder="Add New Status"
                      v-model="status"
                      :options="statu1"
                      class="mb-3"
                    ></b-form-select>
                    <input
                      type="text"
                      class="form-control"
                      id="exampleInputEmail1"
                      v-model="remarks"
                      aria-describedby="emailHelp"
                      placeholder="Remarks"
                    />
                  </div>

                  <button class="btn btn-success" type="submit">UPDATE</button>
                </form>
              </b-modal>
            </td>
          </tr>
          <tr v-if="crimeData.action" id="act">
            <th scope="col">Action</th>
            <td style="font-weight: 500">
              {{ crimeData.action }}
              <!-- <button
                v-b-modal.modal-footer-sm1
                type="button"
                class="btn btn-outline-primary"
                style="
                  padding-top: 0px !important;
                  padding-bottom: 6px !important;
                  padding-left: 4px !important;
                  padding-right: 6px !important;
                "
              >
                Update
              </button> -->

              <span
                v-b-modal.modal-footer-sm1
                style="cursor: pointer"
                class="text-info"
                >Update</span
              >
              <b-modal id="modal-footer-sm1" title button-size="sm" hide-footer>
                <form @submit="onSubmitAct">
                  <div class="form-group">
                    <h5 style="color: black!important; padding-bottom: 20px">
                      Update Action
                    </h5>
                    <b-form-select
                      required
                      placeholder="Add New Action"
                      v-model="action"
                      :options="action1"
                      class="mb-3"
                    ></b-form-select>
                  </div>

                  <button class="btn btn-success" type="submit">UPDATE</button>
                </form>
              </b-modal>
            </td>
          </tr>
          <tr id="priority">
            <th scope="col">Priority</th>
            <td style="font-weight: 500">
              {{ priority }}
              <span
                v-b-modal.modal-footer-sm2
                style="cursor: pointer"
                class="text-info"
                >Update</span
              >
              <b-modal id="modal-footer-sm2" title button-size="sm" hide-footer>
                <div class="form-group">
                  <h5 style="color: black!important; padding-bottom: 20px">
                    Update Priority
                  </h5>
                  <select
                    class="filter pt-2 pb-2"
                    style="width: 100% !important"
                    v-model="priority"
                    @change="priorityChange"
                    :key="priority"
                  >
                    <option value selected disabled hidden>Priority</option>
                    <option value="0">Low</option>
                    <option value="1">Medium</option>
                    <option value="2">High</option>
                  </select>
                </div>
              </b-modal>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-if="crimeData.photos"
      class="row"
      style="padding-left: 10px; padding-right: 10px"
    >
      <div
        v-if="crimeData.photos.length > 0"
        id="info"
        class="border-secondary"
         style="border: #6c757d solid 0.5px !important; width: 100%"
      >
        <div class="card-header p-3">Photos</div>
        <div class="card-body text-secondary">
          <div v-viewer style="display: flex">
            <div
              v-for="image in crimeData.photos"
              :key="image.key"
              class="flex md3 sm12 xs12"
            >
              <b-img
                v-if="image"
                :src="baseURL + image"
                class="image pr-5 lazy"
                style="
                  height: 150px;
                  width: 100%;
                  padding: 10px;
                  object-fit: contain;
                "
                :key="image"
              >
                <template v-slot:placeholder>
                  <b-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <b-spinner label="Spinning"></b-spinner>
                  </b-row>
                </template>
              </b-img>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="crimeData.videos"
      class="row"
      style="padding-top: 30px; padding-left: 10px; padding-right: 10px"
    >
      <div
        v-if="crimeData.videos.length > 0"
        id="info"
        class="border-secondary"
        style="border: #6c757d solid 0.5px !important; width: 100%"
      >
        <div class="card-header p-3">
          Videos(Please double click to view video in fullscreen)
        </div>
        <div class="card-body text-secondary">
          <div style="display: flex">
            <div
              v-for="image in crimeData.videos"
              :key="image"
              class="flex md4 sm12 xs12"
            >
              <video
                class="pr-5"
                width="100%"
                height="auto"
                style="object-fit: cover"
                controls
              >
                <source :src="mediaURL + image" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="crimeData.audioClips"
      class="row"
      style="padding-top: 30px; padding-left: 10px; padding-right: 10px"
    >
      <div
        v-if="crimeData.audioClips.length > 0"
        id="info"
        class="border-secondary"
        style="border: #6c757d solid 0.5px !important; width: 100%"
      >
        <div class="card-header p-3">Audios</div>
        <div class="card-body text-secondary">
          <div style="display: flex">
            <div
              v-for="audio in crimeData.audioClips"
              :key="audio"
              class="flex md4 sm12 xs12"
            >
              <audio
                class="pr-5"
                width="100%"
                height="auto"
                style="object-fit: cover"
                controls
              >
                <source :src="mediaURL + audio" type="audio/mp4" />
              </audio>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="crimeData.timeline && crimeData.timeline.length > 0"
      class="row mt-3 mx-0 pb-4"
    >
      <div class="col-12 px-0">
        <div
          class="card-header p-2 mb-3"
          style="
            background-color: #f8f9fa;
            border: 1px solid #dee2e6;
            border-radius: 4px;
            font-weight: 600;
            color: #495057;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            font-size: 0.85rem;
          "
        >
          Case Timeline
        </div>
        <div class="timeline-container">
          <div
            v-for="(log, index) in crimeData.timeline"
            :key="index"
            class="timeline-item"
          >
            <div class="timeline-dot"></div>
            <div class="timeline-content">
              <div class="timeline-header">
                <h6 class="timeline-action">{{ log.action }}</h6>
                <span class="timeline-date">{{
                  formatDateTime(log.updateDate)
                }}</span>
              </div>
              <p class="timeline-remarks">{{ formatTimelineRemarks(log) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
  props: ["crimeData", "isStatus", "priority", "appUser"],
  data() {
    return {
      status: null,
      action: null,
      remarks: null,
      statu1: [],
      action1: [],
      //  audioClips: [
      //   "http://soundbible.com/mp3/Elevator Ding-SoundBible.com-685385892.mp3",
      //   "http://soundbible.com/mp3/Elevator Ding-SoundBible.com-685385892.mp3",
      // ],
    };
  },
  beforeMount() {
    // this.getMap();
    this.getStatus();
    this.getAction();
    // this.status=  this.crimeData.status.charAt(0).toUpperCase() +
    //             this.crimeData.status.slice(1)
  },
  methods: {
    formatTimelineRemarks(log) {
      if (log.action === 'Priority updated' || log.action === 'priority updated') {
        const val = String(log.remarks).trim();
        if (val === '0') return 'Low';
        if (val === '1') return 'Medium';
        if (val === '2') return 'High';
      }
      return log.remarks;
    },
    onSubmit(evt) {
      this.visible = true;
      evt.preventDefault();
      var data1 = {};
      data1["id"] = this.editingItem._id;
      data1["adminDescription"] = this.editingItem.descriptionMsg;
      axios({
        method: "POST",
        url: "/crimereports/add/update/adminDescription",
        data: data1,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.visible = false;
            this.$emit("stepper", {
              // type: "verification",
              response: response.data,
            });

            this.descriptionModal = false;
          } else {
            this.visible = false;
          }
        })
        .catch((err) => {
          console.log(err);
          // if (err.response.data.status === false) {
          //   this.msg = "Please Try Again";
          // }
        });
    },
    getStatus() {
      axios({
        method: "GET",
        url: "/status/list",
      })
        .then((response) => {
          this.statu1 = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    formatDateTime(date) {
      return moment(date).format("DD-MM-YYYY hh:mm A");
    },
    getAction() {
      axios({
        method: "GET",
        url: "/admin/actions/list",
      })
        .then((response) => {
          this.action1 = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSubmit(evt) {
      // this.visible = true
      var data1 = {};
      data1["status"] = this.status;
      data1["remarks"] = this.remarks;
      data1["id"] = this.crimeData._id;
      evt.preventDefault();
      axios({
        method: "POST",
        url: "/crimereports/change/status",
        data: data1,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.msg = response.data.msg;
          // console.log(this.statu)
          this.$emit("stepper", {
            // type: "verification",
            response: response.data,
          });
          if (response.data.status === true) {
            this.visible = "false";
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push("/reportsview/" + this.id);
              },
              { messageType: "success" }
            );
            window.location.reload();
          } else {
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push("/reportsview/" + this.id);
              },
              { messageType: "error" }
            );
            window.location.reload();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    onSubmitAct(evt) {
      // this.visible = true
      var data1 = {};
      data1["action"] = this.action;
      data1["id"] = this.crimeData._id;
      evt.preventDefault();
      axios({
        method: "POST",
        url: "/crimereports/change/action",
        data: data1,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.msg = response.data.msg;
          // console.log(this.statu)
          if (response.data.status === true) {
            this.visible = false;
            this.$emit("stepper", {
              // type: "verification",
              response: response.data,
            });
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push("/reportsview/" + this.id);
              },
              { messageType: "success" }
            );
            window.location.reload();
          } else {
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push("/reportsview/" + this.id);
              },
              { messageType: "error" }
            );
            window.location.reload();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    priorityChange() {
      var data = {};
      data["id"] = this.crimeData._id;
      data["priority"] = this.priority;

      axios({
        method: "POST",
        url: "/crimereports/update/priority",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: data,
      })
        .then((response) => {
          if (response.data.status) {
            this.$emit("stepper", {
              // type: "verification",
              response: response.data,
            });
            // this.getDetails();
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "success" });
            this.$bvModal.hide("modal-footer-sm2");
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style>
#myMap {
  height: 300px;
  width: 100%;
}

.timeline-container {
  position: relative;
  padding-left: 1.5rem;
  margin-top: 0.5rem;
  z-index: 0;
}

.timeline-container::before {
  content: "";
  position: absolute;
  left: 5px;
  top: 5px;
  bottom: 5px;
  width: 2px;
  background: #e9ecef;
  z-index: -1;
}

.timeline-item {
  position: relative;
  padding-bottom: 1rem;
}

.timeline-item:last-child {
  padding-bottom: 0;
}

.timeline-dot {
  position: absolute;
  left: -1.5rem;
  top: 6px;
  width: 12px;
  height: 12px;
  background: #fff;
  border: 2px solid #6c757d;
  border-radius: 50%;
  z-index: 1;
}

.timeline-item:last-child .timeline-dot {
  border-color: #28a745;
  background-color: #28a745;
}

.timeline-content {
  position: relative;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 0.4rem;
  padding: 0.6rem 0.8rem;
  transition: all 0.2s ease;
}

.timeline-content:hover {
  box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.05);
  border-color: #dee2e6;
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.25rem;
}

.timeline-action {
  font-size: 0.85rem;
  font-weight: 700;
  margin: 0;
  color: #2c3e50;
}

.timeline-date {
  font-size: 0.75rem;
  color: #6c757d;
  white-space: nowrap;
  margin-left: 0.5rem;
}

.timeline-remarks {
  font-size: 0.8rem;
  color: #5a6c7d;
  margin: 0;
  line-height: 1.3;
}
</style>